export default __webpack_public_path__ + "static/media/stefano.8ba5617e.jpg";